<template>
  <van-popup
    v-model="visible"
    :close-on-click-overlay="false"
    position="center"
    :class="_.block"
    :safe-area-inset-bottom="false"
  >
    <div :class="_.grow" />
    <div :class="_.main">
      <div :class="_.hd">
        <div :class="_.title">请输入{{ type }}支付密码</div>
        <van-icon name="cross" :class="_.close" @click="visible = false" />
      </div>
      <div :class="_.bd">
        <van-password-input
          :value="inputValue"
          :mask="true"
          :focused="true"
          :length="6"
        />
      </div>
    </div>

    <van-number-keyboard
      :safe-area-inset-bottom="true"
      :class="_.keyboard"
      :show="true"
      :hide-on-click-outside="false"
      random-key-order
      @blur="visible = false"
      @input="handleInput"
      @delete="handleDelete"
    />
  </van-popup>
</template>

<script>
  import { fromPairs, toArray } from 'vtils'

  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      type: {
        type: String,
        default: '工会卡',
      },
      data: {
        type: Array,
        default: () => [],
      },
      config: {
        type: Array,
        default: () => [
          { key: 73369, keySlat: 73370, value: 'a+9G3u0Bv6JOd93cqjtOqw==' },
          {
            key: 80057,
            keySlat: 80049,
            value: 'SnGrDBn0uGMgJzvxQDL5RA==',
          },
          { key: 60161, keySlat: 60165, value: '7OtiUcMVscmMIH5bWH6wsg==' },
          {
            key: 47084,
            keySlat: 47086,
            value: '62N1vJRKzHk0Dlh12kJUqA==',
          },
          { key: 80129, keySlat: 80134, value: 'p+a/kkTb2rwP+aEsMuL5BA==' },
          {
            key: 89577,
            keySlat: 89583,
            value: 'IoXfuMqdTdsSkHLFffDzyA==',
          },
          { key: 93333, keySlat: 93328, value: 'QqkWXEv4JYjfy+1179fJFQ==' },
          {
            key: 99763,
            keySlat: 99762,
            value: 'cxc6o2aNCpYjaoQsjDJlaQ==',
          },
          { key: 98641, keySlat: 98641, value: '17D02H6hhPadUN0MFos2ZA==' },
          {
            key: 97847,
            keySlat: 97854,
            value: '62ORCSeGyH7g68XpnVfvqA==',
          },
        ],
      },
    },
    data() {
      return {
        inputValue: '',
      }
    },
    computed: {
      keyMap() {
        return fromPairs(
          this.config.map(ele => {
            return [ele.key ^ ele.keySlat, ele.value]
          }),
        )
      },
      valueMap() {
        return fromPairs(
          this.config.map(ele => {
            return [ele.value, ele.key ^ ele.keySlat]
          }),
        )
      },
      visible: {
        get() {
          return this.value
        },
        set(v) {
          this.$emit('input', v)
        },
      },
    },
    watch: {
      data: {
        deep: true,
        immediate: true,
        handler(data) {
          this.setInputValue(data)
        },
      },
    },
    methods: {
      handleInput(val) {
        if (this.inputValue.length < 6) {
          this.inputValue = `${this.inputValue}${val}`
          if (this.inputValue.length === 6) {
            this.$nextTick(() => {
              const tempValue = toArray(this.inputValue).map(
                ele => this.keyMap[ele],
              )
              this.visible = false
              this.$emit('confirm', tempValue)
            })
          }
        }
      },
      handleDelete() {
        if (this.inputValue.length !== 0) {
          this.inputValue = this.inputValue.substr(
            0,
            this.inputValue.length - 1,
          )
        }
      },
      setInputValue(data) {
        this.inputValue = data
          .map(ele => this.valueMap[ele])
          .reduce((last, next) => `${last}${next}`, '')
      },
    },
  }
</script>

<style lang="scss" module>
  .block {
    background: transparent;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .grow {
    flex-grow: 1;
  }

  .main {
    margin: auto;
    width: 327px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;

    .hd {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .title {
        font-size: 16px;
        font-weight: var(--bold-value);
        color: #333333;
        line-height: 22px;
      }

      .close {
        position: absolute;
        top: -8px;
        right: -8px;
        font-size: 22px;
        color: #222222;
      }
    }

    .bd {
      margin-top: 16px;
    }
  }

  .keyboard {
    position: relative !important;
    margin-top: 170px;
  }
</style>
